// ----------------------------------------------------------------------

export default function ImageListItem() {
  return {
    MuiImageListItem: {
      styleOverrides: {
        root: {
          ".MuiImageListItem-img": {
            maxHeight: "100%",
            objectFit: "contain",
          },
        },
      },
    },
  };
}
